import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import LocationListing from './location-listing';

class LocationsList extends React.Component {
    static propTypes = {
        list: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                address: PropTypes.shape({
                    region: PropTypes.string,
                }),
            })
        ).isRequired,
        method: PropTypes.string.isRequired,
        onLocationClick: PropTypes.func.isRequired,
        is_test_order: PropTypes.bool.isRequired,
    };

    shouldComponentUpdate = props => {
        const { method, list, is_test_order } = this.props;
        return (
            props.method !== method ||
            props.is_test_order !== is_test_order ||
            _.reduce(props.list, (ids, item) => ids + item.id, '') !==
                _.reduce(list, (ids, item) => ids + item.id, '') ||
            _.reduce(
                props.list,
                (distance, item) => distance + item.distance_to_customer,
                ''
            ) !==
                _.reduce(
                    list,
                    (distance, item) => distance + item.distance_to_customer,
                    ''
                )
        );
    };

    render() {
        const { list, method, onLocationClick, is_test_order } = this.props;

        let last_region = null;
        const elements = [];
        const num_locations = list.length;
        const num_regions = _.uniq(
            _.map(list, location => location.address.region)
        ).length;

        if (num_regions === 1) {
            elements.push(
                <div
                    key={`${list[0].address.region} ${list[0].id}`}
                    className="m2g-locations-finder-list-region-heading"
                >
                    <div className="m2g-locations-finder-list-region-heading-content">
                        {list[0].address.region}
                    </div>
                </div>
            );
            elements.push(
                <div
                    className="m2g-locations-finder-list-region-list"
                    key="region-list"
                >
                    {_.map(list, location => (
                        <LocationListing
                            method={method}
                            onMethodClick={method_to_set =>
                                onLocationClick(location, method_to_set)
                            }
                            key={`${location.id} ${location.distance_to_customer}`}
                            location={location}
                            is_test_order={is_test_order}
                        />
                    ))}
                </div>
            );
        } else {
            _.each(list, location => {
                if (location.address.region !== last_region) {
                    elements.push(
                        <div
                            key={`${location.address.region} ${location.id}`}
                            className="m2g-locations-finder-list-region-heading"
                        >
                            <div className="m2g-locations-finder-list-region-heading-content">
                                {(last_region = location.address.region)}
                            </div>
                        </div>
                    );
                }
                elements.push(
                    <LocationListing
                        method={method}
                        onMethodClick={method_to_set =>
                            onLocationClick(location, method_to_set)
                        }
                        key={`${location.id} ${location.distance_to_customer}`}
                        location={location}
                        is_test_order={is_test_order}
                    />
                );
            });
        }

        return (
            <div
                className="m2g-locations-finder-list"
                data-num-regions={num_regions}
                data-num-locations={num_locations}
            >
                {elements}
            </div>
        );
    }
}

export default LocationsList;
